module.exports = "/cabinet/img/header-logo-mobile.0d6e5610.svg";